import { useAppMode } from '../context/AppModeContext';

export default function ModeChooserPage() {
  const { setAppMode } = useAppMode();

  return (
    <div className="mode-chooser-container">
      <div className="mode-chooser-card">
        <div className="auth-logo">
          <img src="/logo-pocketrams.png" alt="PocketRAMS" />
        </div>
        <h2>How would you like to use PocketRAMS?</h2>
        <div className="mode-options">
          <button className="mode-option mode-option-primary" onClick={() => setAppMode('dataEntry')}>
            <span className="mode-option-title">Data Entry Mode</span>
            <span className="mode-option-desc">Quick access to create and continue reports</span>
          </button>
          <button className="mode-option" onClick={() => setAppMode('fullSite')}>
            <span className="mode-option-title">Full Website</span>
            <span className="mode-option-desc">Dashboard, reports, locations, and all features</span>
          </button>
        </div>
      </div>
    </div>
  );
}
